import { DataGrid, type DataGridProps } from '@shared/components';

export type BaseExamCenterMemberDataGridProps = Omit<
  DataGridProps,
  'sx' | 'rowHeight' | 'hideFooter' | 'disableColumnMenu'
>;

export default function BaseExamCenterMemberDataGrid(
  props: Readonly<BaseExamCenterMemberDataGridProps>,
) {
  return (
    <DataGrid
      {...props}
      hideFooter
      disableColumnMenu
      rowHeight={68}
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[300]}`,
        backgroundColor: theme.palette.background.paper,
        minHeight: '100%',
        '.MuiDataGrid-cell': {
          p: theme.spacing(3),
          alignItems: 'flex-start',
        },
        '.MuiDataGrid-columnHeaders': {
          backgroundColor: theme.palette.grey[100],
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '.MuiDataGrid-row > .MuiDataGrid-withBorderColor': {
          borderBottom: `1px solid ${theme.palette.grey[300]}`,
        },
        '--DataGrid-overlayHeight': '404px',
      })}
    />
  );
}
